import React$1, { useReducer, useRef, useEffect } from 'react';
import { objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes$1 from 'prop-types';
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

const NavigationContext = React$1.createContext();

function reducer(state, action) {
  switch (action.type) {
    case 'toggleNavigation':
      return _objectSpread2(_objectSpread2({}, state), {}, {
        isOpen: !state.isOpen,
        activePrimaryNavItem: null
      });

    case 'resetNavigation':
      return _objectSpread2(_objectSpread2({}, state), {}, {
        isOpen: false,
        activePrimaryNavItem: null
      });

    case 'resetPrimaryNavigation':
      return _objectSpread2(_objectSpread2({}, state), {}, {
        activePrimaryNavItem: null
      });

    case 'setActivePrimaryNavigation':
      return _objectSpread2(_objectSpread2({}, state), {}, {
        activePrimaryNavItem: action.id
      });

    case 'setHiddenNavigationElements':
      return _objectSpread2(_objectSpread2({}, state), {}, {
        hiddenNavigationElements: action.payload
      });

    default:
      throw new Error(`${action.type} not available`);
  }
}

const NavigationProvider = ({
  children
}) => {
  const [state, dispatch] = useReducer(reducer, {
    isOpen: false,
    activePrimaryNavItem: null,
    hiddenNavigationElements: false
  });
  const listRef = useRef(null);
  useEffect(() => {
    if (state.isOpen) {
      disableBodyScroll(listRef.current);
    } else {
      enableBodyScroll(listRef.current);
    }
  }, [state.isOpen]);
  useEffect(() => () => {
    clearAllBodyScrollLocks();
  }, []);

  const toggleNavigation = () => {
    dispatch({
      type: 'toggleNavigation'
    });
  };

  const setActivePrimaryNavigation = id => {
    dispatch({
      type: 'setActivePrimaryNavigation',
      id
    });
  };

  const resetPrimaryNavigation = () => {
    dispatch({
      type: 'resetPrimaryNavigation'
    });
  };

  const setHiddenNavigationElements = payload => {
    dispatch({
      type: 'setHiddenNavigationElements',
      payload
    });
  };

  return /*#__PURE__*/React$1.createElement(NavigationContext.Provider, {
    value: _objectSpread2(_objectSpread2({}, state), {}, {
      toggleNavigation,
      setActivePrimaryNavigation,
      resetPrimaryNavigation,
      setHiddenNavigationElements,
      listRef
    })
  }, children);
};

NavigationProvider.propTypes = {
  children: PropTypes$1.node.isRequired
};
const NavigationConsumer = NavigationContext.Consumer;

export default NavigationProvider;
export { NavigationConsumer, NavigationContext };
